export const Regions = ["eu-central-1", "us-east-1"]
export const GlobalRegion = "eu-central-1"